module.exports = __webpack_public_path__ + "static/media/GIF_Website_ICAPS.376f1cc4.mp4";